import React, { useState } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import {
  Box,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Stack,
} from "@mui/material";

// Sample data including month and year
const dataAgreements = [
  { name: "Active Agreements", value: 300, month: "August", year: 2024 },
  { name: "Expired Agreements", value: 200, month: "August", year: 2024 },
  { name: "Active Agreements", value: 250, month: "September", year: 2024 },
  { name: "Expired Agreements", value: 230, month: "September", year: 2024 },
  { name: "Active Agreements", value: 320, month: "March", year: 2024 },
  { name: "Expired Agreements", value: 190, month: "March", year: 2024 },
  // Add more data for other months and years...
];

const AgreementStatus = () => {
  // State for selected month and year
  const [selectedMonth, setSelectedMonth] = useState("August");
  const [selectedYear, setSelectedYear] = useState(2024);
  const [isOverall, setIsOverall] = useState(false);

  // Filter data based on selected month and year
  let filteredData;

  if (isOverall) {
    // Aggregate data for the entire year
    const activeTotal = dataAgreements
      .filter(
        (item) =>
          item.year === selectedYear && item.name === "Active Agreements"
      )
      .reduce((acc, curr) => acc + curr.value, 0);

    const expiredTotal = dataAgreements
      .filter(
        (item) =>
          item.year === selectedYear && item.name === "Expired Agreements"
      )
      .reduce((acc, curr) => acc + curr.value, 0);

    filteredData = [
      { name: "Active Agreements", value: activeTotal },
      { name: "Expired Agreements", value: expiredTotal },
    ];
  } else {
    filteredData = dataAgreements.filter(
      (item) => item.month === selectedMonth && item.year === selectedYear
    );
  }

  return (
    <Box>
      {/* Dropdown for selecting month */}

      <Stack direction={"row"} gap={3}>
        {!isOverall && (
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel id="month-select-label">Month</InputLabel>
            <Select
              labelId="month-select-label"
              value={selectedMonth}
              label="Month"
              onChange={(e) => setSelectedMonth(e.target.value)}
            >
              <MenuItem value="August">August</MenuItem>
              <MenuItem value="September">September</MenuItem>
              <MenuItem value="March">March</MenuItem>
              {/* Add more months as needed */}
            </Select>
          </FormControl>
        )}

        {/* Dropdown for selecting year */}
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="year-select-label">Year</InputLabel>
          <Select
            labelId="year-select-label"
            value={selectedYear}
            label="Year"
            onChange={(e) => {
              setSelectedYear(e.target.value);
              setIsOverall(e.target.value === "overall"); // Set overall mode when 'Overall Year' is selected
            }}
          >
            <MenuItem value={2024}>2024</MenuItem>
            <MenuItem value="overall">Overall Year</MenuItem>{" "}
            {/* Option for overall year */}
          </Select>
        </FormControl>
      </Stack>

      {/* Pie chart */}
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie dataKey="value" data={filteredData} outerRadius={80} label>
            {filteredData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={index === 0 ? "#fa7907" : "#a107fa"} // Assign colors here
              />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default AgreementStatus;
